<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>食事予約（一括）</v-toolbar>
        <v-card-title class="noPaddingBtm">
        </v-card-title>
        <v-card-text>
          <v-card-text>
            <v-form ref="p1Form" v-model="p1Form" lazy-validation>
              <v-row dense>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <RyouDateFormat v-model="collectiveStartDate" :value="collectiveStartDate" :type="'date'"
                    :format="'$1/$2/$3'" :label="'一括登録開始日'" :min="mealDeadLineDay" :max="getFutureDay()"
                    :rules="dateRules" style="width: 40%;"></RyouDateFormat>
                </v-col>
                <h2>{{this.wavyLineMark}}</h2>
                <v-col cols="5">
                  <RyouDateFormat v-model="collectiveEndDate" :value="collectiveEndDate" :type="'date'"
                    :format="'$1/$2/$3'" :label="'一括登録終了日'" :min="selectMin" :max="getFutureDay()" :rules="dateRules"
                    style="width: 40%;"></RyouDateFormat>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              <v-container style="height: 216px;overflow-y: auto;">
                <v-row v-for="(item, index) in contentValue" :key="index">
                  <v-spacer></v-spacer>
                  <v-col cols="4">
                    <v-subheader>
                      <v-icon large color="blue" v-if="item.reserve_flg" @click="item.reserve_flg = !item.reserve_flg">
                        mdi-check-circle
                      </v-icon>
                      <v-icon large v-if="!item.reserve_flg" @click="item.reserve_flg = !item.reserve_flg">
                        mdi-checkbox-blank-circle-outline
                      </v-icon>
                      {{item.meal_name}}
                    </v-subheader>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'一括登録'" :handlerClick="submitInsert" :disabled="collectiveBtnCtrl">
            </ryou-black-btn>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'一括解除'" :handlerClick="submitClear" :disabled="collectiveBtnCtrl">
            </ryou-black-btn>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :disabled="closeBtnCtrl" :iconCls="'mdi-close'">
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
  export default {
    name: "MealReservationCollectiveDialog",
    components: {
      RyouBlackBtn,
      RyouDateFormat
    },
    mounted() {
      this.dateRules.push(this.GlobalRules.required);
    },
    data() {
      return {
        p1Form: true,
        dateRules: [],
        dialog: false,
        selectMin: "",
        wavyLineMark: "　～　",
        mealDeadLineDay: "",
        collectiveStartDate: "",
        collectiveEndDate: "",
        collectiveBtnCtrl: null,
        closeBtnCtrl: false,
        contentValue: [],
        groupOptionValue: "",
        reserveUserOptionValue: "",
        updateResult: {}
      };
    },
    created() {
    },
    watch: {
      collectiveStartDate(value) {

        if (value != null && value != "") {
          this.selectMin = value;
        } else {
          this.selectMin = this.mealDeadLineDay;
        }
        let fromDate = new Date(
          Date.parse(this.collectiveStartDate)
        );
        let toDate = new Date(
          Date.parse(this.collectiveEndDate)
        );
        if (fromDate.getTime() > toDate.getTime()) {
          this.collectiveEndDate = "";
        }
      },
    },
    methods: {
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      getFutureDay() {
        let future = new Date();
        future.setMonth(future.getMonth() + 2);
        let futureMonth = (future.getMonth() + 1).toString();

        if (futureMonth.length == 1) {
          futureMonth = "0" + futureMonth;
        }

        return future.getFullYear() + "-" + futureMonth + "-" + future.getDate();
      },
      //ページローディング要求インターフェース、取得値
      // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID
      getInputValue(value, buildGroupSelectValue, reserveUserSelectValue, DeadLineDay) {

        if (buildGroupSelectValue) {
          this.groupOptionValue = buildGroupSelectValue;
        }
        if (reserveUserSelectValue) {

          this.reserveUserOptionValue = reserveUserSelectValue;
        }
        if (value) {
          this.contentValue = value;
        }

        this.mealDeadLineDay = DeadLineDay;
        this.selectMin = DeadLineDay;

        this.open();
      },
      // パラメータをクリア
      clearParameters() {

        this.mealDeadLineDay = "";
        this.collectiveStartDate = "";
        this.collectiveEndDate = "";
        this.$refs.p1Form.reset();
        this.$refs.p1Form.resetValidation();
        this.collectiveBtnCtrl = null;
        this.contentValue = [];
        this.groupOptionValue = "";
        this.reserveUserOptionValue = "";
      },
      submitInsert() {
        this.submit(true);
      },
      submitClear() {
        this.submit(false);
      },
      submit(value) {

        var valid = this.$refs.p1Form.validate();

        if (valid) {
          let updateResultBean = {
            build_group_id: this.groupOptionValue,
            edit_user_id: this.reserveUserOptionValue,
            collectiveUpdateStartDate: this.collectiveStartDate,
            collectiveUpdateEndDate: this.collectiveEndDate,
            reserve_entity: [],
            insert_clear_flg: value,
            user_id: this.$store.getters.getUserId
          };
          this.updateResult = updateResultBean;

          this.contentValue.forEach((item) => {
            let updateItem = null;
            // 一括登録
            if (value) {
              updateItem = {
                meal_class: item.meal_class,
                reserve_flg: Number(item.reserve_flg).toString()
              };
            }
            //一括解除
            else {
              item.reserve_flg = false;
              updateItem = {
                meal_class: item.meal_class,
                reserve_flg: Number(false).toString()
              };
            }

            this.updateResult.reserve_entity.push(updateItem);
          });

          this.collectiveBtnCtrl = true;
          this.closeBtnCtrl = true;

          this.putRequest("/mealReservation/mealReserveCollectiveUpdate", this.updateResult, this.$store.getters.getUserToken).then(() => {

            this.collectiveBtnCtrl = false;
            this.closeBtnCtrl = false;
          });

        }
      },
      close() {
        this.dialog = false;

        this.clearParameters();
        this.$emit("reCalendar");
      },
      open() {
        this.dialog = true;
      }
    }
  }
</script>

<style scoped>
  .noPaddingBtm {
    height: 48px;
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }
</style>